import { FunctionComponent } from "react";
export interface TabProps {
  label: any;
  children: any;
}

export const Tab: FunctionComponent<TabProps> = ({ children, label }) => {
  return <div>{children}</div>;
};
